module.exports = __webpack_public_path__ + "static/media/walmart.ba5b9f49.png";